import NumberInput from "./NumberInput";
new NumberInput();